import React from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import performer from "assets/img/performer.png";

const useStyles = makeStyles(styles);

export default function InProgress() {
    const classes = useStyles();

    return (
        <div>
            <GridContainer>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={4}>
                    <Card>
                        <CardBody>
                            <img src={performer} alt="performer" style={{width:"100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
};